import { render, staticRenderFns } from "./AddBankAccountDialog.vue?vue&type=template&id=6b9aa886&"
import script from "./AddBankAccountDialog.vue?vue&type=script&lang=js&"
export * from "./AddBankAccountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports